import './App.css';
import { router } from "./Pages/index";
import { RouterProvider } from "react-router-dom";
import React, { useEffect } from 'react';
import { initTheme, applyTheme } from './utils/configService';

// Inicializar tema de inmediato antes del renderizado
initTheme();

function App() {
  useEffect(() => {
    // Sincronizar tema con la base de datos al montar
    initTheme();

    // Escuchar cambios de configuración para actualizar el tema en tiempo real
    const handleConfigChange = (e) => {
      if (e?.detail?.themeColor) {
        applyTheme(e.detail.themeColor);
      }
    };

    const handleStorageChange = (e) => {
      if (e.key === 'system_config') {
        try {
          const parsed = JSON.parse(e.newValue);
          if (parsed?.themeColor) {
            applyTheme(parsed.themeColor);
          }
        } catch (err) {
          console.error(err);
        }
      }
    };

    window.addEventListener('configUpdated', handleConfigChange);
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('configUpdated', handleConfigChange);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <RouterProvider router={router} />
  );
}

export default App;
